import { Grid } from '@mui/material';

import { makeStyles } from "@material-ui/core/styles";
import AccordionList from './AccordionList';
import PieChart from './PieChart';
import StackBarChart from './StackBarChart';

const ContentUsageSummary = (props) => {
    let {trainerReportData, fetchTrainer} = props;
    const classes = useStyles();

    trainerReportData.sort(function compare(a, b) {
        let dateA = new Date(b.totalTime);
        let dateB = new Date(a.totalTime);
        return dateA - dateB;
    });  
      
    return (
        <Grid container   sx={{ height: '68vh', overflow: 'auto', px: 1 }}>
            <Grid item xs={trainerReportData.length == 1 ? 6 : 12}>
                {trainerReportData.length === 1 &&
                    <PieChart
                        pieChartData={trainerReportData}
                        chartHeight={'400px'}
                    />
                }
                {trainerReportData.length > 1 &&
                    <StackBarChart
                        fetchTrainer={fetchTrainer}
                        stackBarData={trainerReportData}
                        isHorizontal={true}
                        chartWidth={'95%'}
                        chartHeight={'850px'}
                    />
                }
            </Grid>
            <Grid item xs={trainerReportData.length == 1 ? 6 : 12} >
                <AccordionList
                    trainerReportData={trainerReportData}
                    fetchTrainer={fetchTrainer}
                ></AccordionList>
            </Grid>
        </Grid>
    )
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        }
    },
});
export default ContentUsageSummary;